<script setup lang="ts">
  import { cn } from "@/lib/utils"
  import { HTMLAttributes } from "vue"
  import { Icon } from "@/components/ui/icons"

  const props = defineProps<{
    class?: HTMLAttributes["class"]
  }>()

  const emits = defineEmits(["close"])

  const closeAlert = () => {
    emits("close")
  }
</script>

<template>
  <Icon
    name="Close"
    label="Close alert"
    size="lg"
    :class="
      cn(
        'text-current hover:bg-transparent active:bg-transparent dark:hover:bg-transparent dark:active:bg-transparent sm:p-0',
        props.class,
      )
    "
    data-testid="alert-close"
    @click="closeAlert"
  />
</template>
